import classnames from 'classnames';

import style from '../style.module.scss';
import type { OpeningHoursInfo } from '../interface';

interface StationMetaRowsProps {
    openingHours?: OpeningHoursInfo | null;
    stationType?: string | null;
    statusLabel: string;
    statusClassName: string;
    distanceReferenceLabel: string;
    distanceLabel: string;
}

const StationMetaRows = ({
    openingHours,
    stationType,
    statusLabel,
    statusClassName,
    distanceReferenceLabel,
    distanceLabel,
}: StationMetaRowsProps) => {
    const renderSchedule = () => {
        if (openingHours?.is24_7) {
            return (
                <div className={style.stationRow}>
                    <span className={style.stationLabel}>Program</span>
                    <span className={style.stationValue}>Deschis 24/7</span>
                </div>
            );
        }

        if (openingHours && openingHours.days.length > 0) {
            return (
                <div className={classnames(style.stationRow, style.stationRowColumn)}>
                    <span className={style.stationLabel}>Program</span>
                    <div className={style.stationSchedule}>
                        {openingHours.days.map((day) => (
                            <div key={day.label} className={style.stationScheduleDay}>
                                <span className={style.stationScheduleLabel}>{day.label}</span>
                                <span className={style.stationScheduleHours}>{day.hours}</span>
                            </div>
                        ))}
                    </div>
                </div>
            );
        }

        return (
            <div className={style.stationRow}>
                <span className={style.stationLabel}>Program</span>
                <span className={style.stationValue}>-</span>
            </div>
        );
    };

    return (
        <div className={style.stationRows}>
            {renderSchedule()}
            <div className={style.stationRow}>
                <span className={style.stationLabel}>Amplasare stație</span>
                <span className={style.stationValue}>{stationType || '-'}</span>
            </div>
            <div className={style.stationRow}>
                <span className={style.stationLabel}>Status</span>
                <span className={classnames(style.stationStatusBadge, statusClassName)}>
                    {statusLabel}
                </span>
            </div>
            <div className={style.stationRow}>
                <span className={style.stationLabel}>{distanceReferenceLabel}</span>
                <span className={style.stationValue}>{distanceLabel}</span>
            </div>
        </div>
    );
};

export default StationMetaRows;
